/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import Button from "../../Button";
import Modal from "../../Modal/Modal";
import Typography from "../Typography/Typography";

const defaultMessage = "Are you sure?";

export default function AlertForMobile({
  open,
  onClose,
  onSubmit,
  text = defaultMessage,
}) {
  return (
    <Box>
      <Modal
        open={open}
        onClose={onClose}
        // fullWidth="50%"
        // PaperProps={{ sx: { minHeight: 100 } }}
        // aria-labelledby="alert-dialog-title"
        // aria-describedby="alert-dialog-description"
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
              paddingBottom: "20px",
            }}
          >
            {text}
          </Typography>
        </Box>
        <Box
          style={{
            paddingTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={onSubmit}
            label="Yes"
            style={{
              marginRight: "10px",
            }}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}
